import React from 'react';
import { motion } from 'framer-motion';

const ShippingPolicyPage: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 py-24 animate-fade-in">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <p className="text-xs tracking-widest uppercase text-nude mb-3">
          Customer Care
        </p>
        <h1 className="font-serif text-5xl text-primary mb-12">
          Shipping Policy
        </h1>

        <div className="space-y-10 text-sm text-secondary leading-relaxed tracking-wide">
          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Processing Time
            </h2>
            <p>
              All orders are processed within 1-3 business days. Orders
              placed on weekends or public holidays will be processed on the
              next business day. You will receive a confirmation email once
              your order has been dispatched.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Shipping Methods
            </h2>
            <div className="space-y-4">
              {[
                {
                  name: 'Standard Shipping',
                  time: '5-7 business days',
                  cost: '$15.00',
                },
                {
                  name: 'Express Shipping',
                  time: '2-3 business days',
                  cost: '$30.00',
                },
                {
                  name: 'Overnight Shipping',
                  time: '1 business day',
                  cost: '$50.00',
                },
                {
                  name: 'Free Shipping',
                  time: '5-7 business days',
                  cost: 'On orders over $300',
                },
              ].map((method) => (
                <div
                  key={method.name}
                  className="flex justify-between border-b border-light pb-4"
                >
                  <div>
                    <p className="font-medium text-primary">{method.name}</p>
                    <p className="text-xs text-nude mt-1">{method.time}</p>
                  </div>
                  <p className="text-primary">{method.cost}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              International Shipping
            </h2>
            <p className="mb-4">
              We ship to most countries worldwide. International shipping
              rates and delivery times vary by destination. Customs duties
              and taxes may apply and are the responsibility of the recipient.
            </p>
            <p>
              International orders typically take 7-14 business days to
              arrive, depending on the destination country and customs
              processing times.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Order Tracking
            </h2>
            <p>
              Once your order has been shipped, you will receive a tracking
              number via email. You can use this to track your order through
              our website or the carrier's website.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl text-primary mb-4">
              Delivery Issues
            </h2>
            <p>
              If your order has not arrived within the expected timeframe,
              please contact our customer service team at
              shipping@lanresavage.com. We will investigate and resolve the
              issue as quickly as possible.
            </p>
          </div>

          <p className="text-xs text-nude">Last updated: January 2026</p>
        </div>
      </motion.div>
    </div>
  );
};

export default ShippingPolicyPage;